import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowAlignVerticalCentre16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconArrowAlignVerticalCentre16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14.5 8.5a.5.5 0 0 0 0-1h-3.343l1.447-1.446a.5.5 0 0 0-.708-.708L9.598 7.645l-.353.353.353.354 2.298 2.298a.5.5 0 0 0 .708-.707L11.16 8.5zM8 2a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-1 0v-11A.5.5 0 0 1 8 2M1 7.996a.5.5 0 0 1 .5-.5h3.339L3.396 6.053a.5.5 0 0 1 .708-.707l2.298 2.298.353.354-.353.354-2.298 2.298a.5.5 0 1 1-.708-.707l1.447-1.447H1.5a.5.5 0 0 1-.5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowAlignVerticalCentre16);
